import { apiFetch } from '$lib/api/helpers';
import type { InputKeyRequest, InputKeyResponse } from '$lib/types/input_key';

const PATH = '/input_keys/';

export async function fetchInputKeys(deviceId?: number) {
  const endpoint = deviceId ? `${PATH}?device=${deviceId}` : PATH;
  return apiFetch<Array<InputKeyResponse>>(endpoint);
}

export async function createInputKey(request: InputKeyRequest) {
  return apiFetch<InputKeyResponse>(PATH, {
    method: 'POST',
    body: JSON.stringify(request)
  });
}

export async function deleteInputKey(id: number) {
  return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function updateInputKey(id: number, data: Partial<InputKeyRequest>) {
  return apiFetch<InputKeyResponse>(`${PATH}${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(data)
  });
}
